export interface DiscountInfo {
  promoCode: string;
  expiresAt: string;
}

export interface TimeRemaining {
  days: number;
  hours: number;
  minutes: number;
  totalMs: number;
  expired: boolean;
}

// Raised from 24.99 on 2026-10-18 (ADR-0171). The Stripe Payment Link's default price must match this constant.
export const ORIGINAL_PRICE = 34.99;
/** The list price before the 2026-10-19 rise. Purchases made before PRICE_RISE_AT keep showing it in the billing screens. */
export const LEGACY_LIST_PRICE = 24.99;
export const PRICE_RISE_AT = Date.UTC(2026, 9, 19, 0, 0, 0);
export const listPriceAt = (isoDate: string | null | undefined): number =>
  isoDate && new Date(isoDate).getTime() < PRICE_RISE_AT ? LEGACY_LIST_PRICE : ORIGINAL_PRICE;
export const DISCOUNT_PERCENT = 20;
export const DISCOUNTED_PRICE = Math.round(ORIGINAL_PRICE * (1 - DISCOUNT_PERCENT / 100) * 100) / 100; // $27.99

export function getTimeRemaining(expiresAt: string): TimeRemaining {
  const now = new Date().getTime();
  const expiry = new Date(expiresAt).getTime();
  const totalMs = expiry - now;

  if (totalMs <= 0) {
    return { days: 0, hours: 0, minutes: 0, totalMs: 0, expired: true };
  }

  const days = Math.floor(totalMs / (1000 * 60 * 60 * 24));
  const hours = Math.floor((totalMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((totalMs % (1000 * 60 * 60)) / (1000 * 60));

  return { days, hours, minutes, totalMs, expired: false };
}

export function isDiscountActive(expiresAt: string | null | undefined): boolean {
  if (!expiresAt) return false;
  return new Date(expiresAt).getTime() > new Date().getTime();
}

export function formatTimeRemaining(time: TimeRemaining): string {
  if (time.expired) return '';

  const parts: string[] = [];
  if (time.days > 0) parts.push(`${time.days}d`);
  if (time.hours > 0) parts.push(`${time.hours}h`);
  if (time.days === 0) parts.push(`${time.minutes}m`);

  return parts.join(' ');
}
